import { Box } from "@biblioteksentralen/react";
import { ResolvedSommerles, richTextHasContent } from "@libry-content/common";
import { CombinedRichTextType } from "@libry-content/types";
import { useTranslation } from "../../utils/hooks/useTranslation";
import BlockContent from "../blockContent/BlockContent";
import { CampaignViewSection } from "../campaigns/CampaignViewSection";

export const SommerlesViewRichTextBlock = ({ sommerles }: { sommerles: ResolvedSommerles }) => {
  const { ts } = useTranslation();
  const galleryBackgroundColors = getGalleryBackgroundColors(ts(sommerles.text));

  if (!richTextHasContent(ts(sommerles.text))) return null;

  return (
    <CampaignViewSection
      padding="0"
      css={{
        "& > div > div > h2,& > div > div > p": {
          padding: "0 1rem",
        },
        "& h2": {
          marginBottom: "1rem",
        },
      }}
    >
      <Box width="100%">
        <BlockContent blocks={ts(sommerles.text)} galleryBackgroundColors={galleryBackgroundColors} />
      </Box>
      <Box className="group" aria-hidden></Box>
    </CampaignViewSection>
  );
};

const getGalleryBackgroundColors = (blocks: CombinedRichTextType = []) => {
  const colors = ["#5F3473", "#457297", "#387870"];
  const galleries = blocks?.filter(({ _type }) => _type === "gallery") ?? [];

  return galleries.reduce(
    (acc: Record<string, string>, { _key }, idx) => ({
      ...acc,
      [_key]: colors[idx % colors.length]!,
    }),
    {}
  );
};
